
    (function () {
      var configElement = document.getElementById('noku-buybox-config');
      if (!configElement) return;
      var config = JSON.parse(configElement.textContent);
      var syncColorTileState = function () {};

      function syncOptionTiles() {
        document.querySelectorAll('[data-option-tile]').forEach(function (tile) {
          var name = tile.getAttribute('data-option-name');
          var value = tile.getAttribute('data-option-value');
          var group = document.querySelectorAll(
            '#buy_section input[type="radio"][name^="' + name + '-"]'
          );
          var matched = false;
          group.forEach(function (radio) {
            if (radio.value === value && radio.checked) matched = true;
          });
          tile.classList.toggle('is-selected', matched);
        });
      }

      document.addEventListener('click', function (e) {
        var tile = e.target.closest('[data-option-tile]');
        if (!tile) return;
        e.preventDefault();
        var name = tile.getAttribute('data-option-name');
        var value = tile.getAttribute('data-option-value');
        var radios = document.querySelectorAll(
          '#buy_section input[type="radio"][name^="' + name + '-"]'
        );
        radios.forEach(function (radio) {
          if (radio.value === value && !radio.checked) {
            radio.click();
          }
        });
        syncOptionTiles();
        setTimeout(syncOptionTiles, 60);
      });

      document.addEventListener('change', function (e) {
        if (
          e.target &&
          e.target.matches &&
          e.target.matches('#buy_section input[type="radio"]')
        ) {
          syncOptionTiles();
        }
      });

      function setupColorSliders() {
        if (document.querySelector('.color-picker-wrap')) return;
        var tpl = document.getElementById('color-picker-template');
        var buySection = document.getElementById('buy_section');
        var firstColorBlock = document.querySelector('#buy_section .color-select-block');
        if (!tpl || !buySection || !firstColorBlock) return;

        var clone = tpl.content.cloneNode(true);
        buySection.insertBefore(clone, buySection.firstElementChild);

        var selects = {
          top: document.querySelector('#buy_section select[name="properties[Kolor górnej części]"]'),
          bottom: document.querySelector('#buy_section select[name="properties[Kolor dolnej części]"]')
        };

        function syncColorTiles() {
          document.querySelectorAll('[data-color-tile]').forEach(function (tile) {
            var target = tile.getAttribute('data-color-target');
            var value = tile.getAttribute('data-color-value');
            var sel = selects[target];
            tile.classList.toggle('is-selected', !!sel && sel.value === value);
          });
        }
        syncColorTileState = syncColorTiles;

        document.querySelectorAll('[data-color-tile]').forEach(function (tile) {
          tile.addEventListener('click', function () {
            var target = tile.getAttribute('data-color-target');
            var value = tile.getAttribute('data-color-value');
            var sel = selects[target];
            if (sel && sel.value !== value) {
              sel.value = value;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
            syncColorTiles();
          });
        });

        document.addEventListener('change', function (e) {
          if (e.target === selects.top || e.target === selects.bottom) {
            syncColorTiles();
          }
        });

        document.querySelectorAll('[data-color-track]').forEach(function (track) {
          var group = track.closest('.color-slider');
          if (!group) return;
          var prev = group.querySelector('[data-color-slider-prev]');
          var next = group.querySelector('[data-color-slider-next]');
          if (prev) {
            prev.addEventListener('click', function () {
              track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
            });
          }
          if (next) {
            next.addEventListener('click', function () {
              track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
            });
          }
        });

        syncColorTiles();
      }

      function setupPetName() {
        if (document.querySelector('.pet-name-wrap')) return;
        var tpl = document.getElementById('pet-name-template');
        var colorWrap = document.querySelector('.color-picker-wrap');
        var nameField = document.querySelector(
          '#buy_section input[name="properties[Imię pupila]"], #buy_section textarea[name="properties[Imię pupila]"]'
        );
        if (!tpl || !colorWrap || !nameField) return;

        var clone = tpl.content.cloneNode(true);
        colorWrap.parentNode.insertBefore(clone, colorWrap.nextSibling);

        var proxy = document.querySelector('[data-pet-name-proxy]');
        var count = document.querySelector('[data-pet-name-count]');
        if (!proxy) return;

        proxy.value = nameField.value || '';
        if (count) count.textContent = proxy.value.length;

        proxy.addEventListener('input', function () {
          var val = proxy.value.toUpperCase();
          proxy.value = val;
          nameField.value = val;
          nameField.dispatchEvent(new Event('input', { bubbles: true }));
          nameField.dispatchEvent(new Event('change', { bubbles: true }));
          if (count) count.textContent = val.length;
        });

        nameField.addEventListener('input', function () {
          if (document.activeElement !== proxy) {
            proxy.value = nameField.value;
            if (count) count.textContent = nameField.value.length;
          }
        });
      }

      function enhanceNativeNameField() {
        var nameField = document.querySelector(
          '#buy_section input[name="properties[Imię pupila]"], #buy_section textarea[name="properties[Imię pupila]"]'
        );
        if (!nameField) return;

        if (nameField.getAttribute('maxlength') !== '12') {
          nameField.setAttribute('maxlength', '12');
        }

        if (!nameField.dataset.forceUppercaseBound) {
          nameField.dataset.forceUppercaseBound = '1';
          nameField.addEventListener('input', function () {
            var upper = nameField.value.toUpperCase().slice(0, 12);
            if (upper !== nameField.value) nameField.value = upper;
          });
        }

        if (!nameField.dataset.hintHidden) {
          var hints = Array.from(document.querySelectorAll('#buy_section *')).filter(function (el) {
            return el.children.length === 0 &&
              el.textContent &&
              el.textContent.indexOf('WIELKIMI') !== -1 &&
              !el.closest('.pet-name-wrap');
          });
          if (hints.length) {
            hints.forEach(function (el) { el.style.display = 'none'; });
            nameField.dataset.hintHidden = '1';
          }
        }

        if (!nameField.dataset.counterHidden) {
          var counters = document.querySelectorAll('#buy_section .__character-label');
          if (counters.length) {
            counters.forEach(function (el) { el.style.display = 'none'; });
            nameField.dataset.counterHidden = '1';
          }
        }
      }

      var PRODUCT_IMAGE_URL = config.PRODUCT_IMAGE_URL;

      function formatPLN(amount) {
        return amount.toFixed(2).replace('.', ',') + ' zł';
      }

      var shopifyEventsModulePromise = null;
      function getShopifyEventsModule() {
        if (!shopifyEventsModulePromise) {
          shopifyEventsModulePromise = import('https://cdn.shopify.com/storefront/standard-events.js');
        }
        return shopifyEventsModulePromise;
      }

      function notifyCartUpdate(action, lines) {
        getShopifyEventsModule().then(function (mod) {
          var CartLinesUpdateEvent = mod.CartLinesUpdateEvent;
          var deferred = CartLinesUpdateEvent.createPromise();
          document.dispatchEvent(new CartLinesUpdateEvent({
            action: action,
            context: 'product',
            lines: lines,
            promise: deferred.promise
          }));
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (rawCart) {
              deferred.resolve({
                cart: CartLinesUpdateEvent.createCartFromAjaxResponse(rawCart),
                detail: { items: rawCart.items, itemCount: rawCart.item_count, source: 'custom-buybox' }
              });
            })
            .catch(function (err) { deferred.reject(err); });
        }).catch(function () {});
      }

      var cartRefreshSeq = 0;
      function refreshCartState() {
        if (cartMutationBusy) return Promise.resolve();
        var seq = ++cartRefreshSeq;
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (seq !== cartRefreshSeq) return;
            if (cartMutationBusy) return;
            renderCartPanel(cart);
          })
          .catch(function () { showConfiguratorError('Nie udało się odczytać koszyka. Odśwież stronę i spróbuj ponownie.', document.querySelector('[data-confirm-bowl-index="0"]')); });
      }

      document.addEventListener('shopify:cart:lines-update', function (event) {
        if (event.promise && typeof event.promise.then === 'function') {
          event.promise.then(refreshCartState).catch(function () {});
          return;
        }
        refreshCartState();
      });

      window.addEventListener('pageshow', function (event) { if (event.persisted) refreshCartState(); });
      window.addEventListener('focus', function () { if (initialStateRestored) refreshCartState(); });

      if (!window.__nokuCartSyncPatched) {
        window.__nokuCartSyncPatched = true;
        var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)\.js/;
        var nativeFetch = window.fetch.bind(window);
        window.fetch = function (input, init) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var isCartMutation = CART_MUTATION_RE.test(url);
          var result = nativeFetch(input, init);
          if (isCartMutation) {
            result.then(function () { refreshCartState(); }).catch(function () {});
          }
          return result;
        };
      }

      var COLOR_HEX = {
        'Poppy Red': '#E84A34', 'Butter Baby': '#F1E08A', 'Terra Love': '#C1663A',
        'Peachy Nude': '#F0B98C', 'Cherry Wine': '#7A1F35', 'Midnight Blue': '#1E2A5C',
        'Mint Whisper': '#B7E4C7', 'Aqua Splash': '#3AC6C6', 'Olive Mood': '#7C8B4A',
        'Orange Crush': '#F07A22', 'Baby Pink': '#F5B8C4', 'Lilac Haze': '#B39DDB',
        'Baby Blue': '#8EC9E8', 'Loco Pink': '#E6398A', 'Vanilla Cloud': '#F3E9D2',
        'Hot Cocoa': '#5C3A21'
      };

      function setupCoreConfigCard() {
        if (document.querySelector('.core-config-card')) return;
        var buyButtons = document.querySelector('#buy_section buy-buttons-component, #buy_section [class*="buy-buttons"]');
        if (!buyButtons || !buyButtons.parentNode) return;

        var container = buyButtons.parentNode;
        var card = document.createElement('div');
        card.className = 'core-config-card';
        card.setAttribute('aria-hidden', 'true');
        card.inert = true;

        var nodesToWrap = [];
        var node = container.firstChild;
        while (node && node !== buyButtons) {
          nodesToWrap.push(node);
          node = node.nextSibling;
        }
        if (!nodesToWrap.length) return;

        container.insertBefore(card, nodesToWrap[0]);
        nodesToWrap.forEach(function (n) { card.appendChild(n); });
      }

      function setupProofBadges() {
        if (document.querySelector('#buy_section .order-summary-badges')) return;
        var buyButtons = document.querySelector('#buy_section buy-buttons-component, #buy_section [class*="buy-buttons"]');
        if (!buyButtons || !buyButtons.parentNode) return;
        var BADGE_ICONS = {
          truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="7" width="13" height="9" rx="1.5"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="1.7"/><circle cx="17.5" cy="18" r="1.7"/></svg>',
          locker: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M4 7.5l8 4.5 8-4.5"/><path d="M12 12v9"/></svg>',
          shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>'
        };
        var BADGE_DEFS = [
          { icon: 'truck', title: '3–5 dni roboczych', desc: 'Wysyłka' },
          { icon: 'locker', title: 'Darmowa dostawa', desc: 'Do paczkomatów' },
          { icon: 'shield', title: '365 dni', desc: 'Gwarancji' }
        ];
        var badges = document.createElement('div');
        badges.className = 'order-summary-badges';
        badges.innerHTML = BADGE_DEFS.map(function (def) {
          return (
            '<div class="order-summary-badge">' +
              '<span class="order-summary-badge__icon">' + BADGE_ICONS[def.icon] + '</span>' +
              '<span class="order-summary-badge__title">' + def.title + '</span>' +
              '<span class="order-summary-badge__desc">' + def.desc + '</span>' +
            '</div>'
          );
        }).join('');
        buyButtons.parentNode.insertBefore(badges, buyButtons.nextSibling);

      }

      var VARIANT_MAP = config.VARIANT_MAP;

      function emptyBowlState(index) {
        return {
          instanceId: createBowlInstanceId(),
          started: false,
          enabled: index === 0,
          confirmed: false,
          syncedToCart: false,
          model: null,
          size: null,
          topColor: '',
          bottomColor: '',
          petName: '',
          variantId: null,
          price: 0,
          properties: {},
          cartLineKey: null
        };
      }

      function createBowlInstanceId() {
        if (window.crypto && window.crypto.randomUUID) return 'noku_' + window.crypto.randomUUID();
        return 'noku_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
      }

      var configuratorState = {
        bowls: [0, 1, 2, 3, 4].map(emptyBowlState)
      };
      var CONFIG_STORAGE_KEY = 'noku_configurator_state_v1';
      var LEGACY_DRAFT_STORAGE_KEY = 'noku-configurator-drafts-v2';
      var stateHydrating = false;
      var steelDraftState = { size: 'S', quantity: 1 };
      var storedExtraEditorIndex = null;

      function showBowlSuccessToast(message) {
        var toast = document.querySelector('[data-noku-success-toast]');
        var backdrop = document.querySelector('[data-noku-success-backdrop]');
        if (!toast) return;
        toast.querySelector('.noku-success-toast__message').textContent = message || 'Miska jest już w Twoim koszyku.';
        if (toast.dataset.animationBound !== 'true') {
          toast.dataset.animationBound = 'true';
          toast.addEventListener('animationend', function (event) {
            if (event.target !== toast || event.animationName !== 'noku-toast-lifecycle' && event.animationName !== 'noku-toast-fade') return;
            toast.classList.remove('is-visible');
            toast.hidden = true;
            if (backdrop) {
              backdrop.classList.remove('is-visible');
              backdrop.hidden = true;
            }
          });
        }
        if (backdrop) {
          backdrop.hidden = false;
          backdrop.classList.remove('is-visible');
          void backdrop.offsetWidth;
          backdrop.classList.add('is-visible');
        }
        toast.hidden = false;
        toast.classList.remove('is-visible');
        void toast.offsetWidth;
        toast.classList.add('is-visible');
      }

      function refreshConfirmationControls() {
        var price = document.querySelector('[data-main-bowl-price]');
        var mainVariant = getBowlVariant(configuratorState.bowls[0]);
        if (price) price.textContent = mainVariant ? mainVariant.price : '';
        document.querySelectorAll('[data-confirm-bowl-index]').forEach(function (button) {
          var index = Number(button.getAttribute('data-confirm-bowl-index'));
          var bowl = configuratorState.bowls[index];
          var added = !!(bowl && bowl.confirmed && bowl.syncedToCart);
          button.disabled = !initialStateRestored || cartMutationBusy || !isBowlComplete(bowl) || added;
          button.classList.toggle('is-confirmed', added);
          button.textContent = cartMutationBusy && cartActionButton === button ? 'Zapisywanie…' :
            added ? 'W koszyku ✓' :
            bowl && bowl.syncedToCart ? 'Zapisz zmiany w koszyku' :
            index === 0 ? 'Dodaj miskę do koszyka' :
            index === 1 ? 'Dodaj drugą miskę do koszyka' : 'Dodaj kolejną miskę do koszyka';
        });
      }

      function setupConfirmationButtons() {
        document.querySelectorAll('[data-confirm-bowl-index]').forEach(function (button) {
          if (button.dataset.confirmBound === 'true') return;
          button.dataset.confirmBound = 'true';
          button.addEventListener('click', function () {
            if (cartMutationBusy || !initialStateRestored) return;
            var index = Number(button.getAttribute('data-confirm-bowl-index'));
            var bowl = index === 0 ? syncMainBowlState(true) :
              nokuExtraEditorIndex === index ? syncExtraEditor() : configuratorState.bowls[index];
            if (!isBowlComplete(bowl) || bowl.confirmed && bowl.syncedToCart) {
              refreshConfirmationControls();
              return;
            }
            var updating = bowl.syncedToCart;
            runCartMutation(function () {
              return index === 0 ? ensureMainInCart() : syncBowlInstanceToCart(bowl, index);
            }, button).then(function () {
              showBowlSuccessToast(updating ? 'Zmiany w misce zostały zapisane w koszyku.' : 'Miska jest już w Twoim koszyku.');
            }).catch(function (error) {
              showConfiguratorError(error.message, button);
            });
          });
        });
        refreshConfirmationControls();
      }

      function bowlStartedValue(index, markStarted) {
        return !!(configuratorState.bowls[index] && configuratorState.bowls[index].started) || markStarted === true;
      }

      function cartItemInstanceId(item) {
        var props = item && item.properties || {};
        return props['_noku_instance_id'] || props['_noku_bowl_id'] || '';
      }

      function persistDraftBowls() {
        if (stateHydrating) return;
        if (!initialStateRestored && !configuratorState.bowls.some(function (bowl) { return bowl.started; })) return;
        var bowls = configuratorState.bowls.map(function (bowl, index) {
          if (!bowl.started || !bowl.enabled) return null;
          return {
            slotIndex: index,
            instanceId: bowl.instanceId,
            started: !!bowl.started,
            enabled: !!bowl.enabled,
            confirmed: !!bowl.confirmed,
            syncedToCart: !!bowl.syncedToCart,
            cartLineKey: bowl.cartLineKey,
            model: bowl.model,
            size: bowl.size,
            topColor: bowl.topColor,
            bottomColor: bowl.bottomColor,
            petName: bowl.petName,
            variantId: bowl.variantId,
            price: bowl.price
          };
        });
        try {
          sessionStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify({ version: 1, bowls: bowls, steel: steelDraftState, extraEditorIndex: nokuExtraEditorIndex }));
        } catch (error) {}
      }

      function readDraftBowls() {
        try {
          var raw = sessionStorage.getItem(CONFIG_STORAGE_KEY);
          var parsed = raw ? JSON.parse(raw) : null;
          if (parsed && parsed.version === 1 && Array.isArray(parsed.bowls)) {
            storedExtraEditorIndex = parsed.extraEditorIndex != null && Number.isInteger(Number(parsed.extraEditorIndex)) ? Number(parsed.extraEditorIndex) : null;
            if (parsed.steel && typeof parsed.steel === 'object') {
              steelDraftState = {
                size: Object.prototype.hasOwnProperty.call(STEEL_BOWL_VARIANTS, parsed.steel.size) ? parsed.steel.size : 'S',
                quantity: Math.max(1, Math.min(10, Math.floor(Number(parsed.steel.quantity)) || 1))
              };
            }
            return parsed.bowls.filter(Boolean);
          }

          var legacy = JSON.parse(sessionStorage.getItem(LEGACY_DRAFT_STORAGE_KEY) || '[]');
          return Array.isArray(legacy) ? legacy : [];
        } catch (error) {
          return [];
        }
      }

      function isValidStoredBowl(draft) {
        if (!draft || typeof draft !== 'object') return false;
        var index = Number(draft.slotIndex);
        if (!Number.isInteger(index) || index < 0 || index >= configuratorState.bowls.length) return false;
        if (typeof draft.instanceId !== 'string' || !draft.instanceId) return false;
        if (typeof draft.model !== 'string' || typeof draft.size !== 'string') return false;
        if (!VARIANT_MAP[draft.model + '|' + draft.size]) return false;
        if (typeof draft.topColor !== 'string' || typeof draft.bottomColor !== 'string') return false;
        if (draft.topColor && !Object.prototype.hasOwnProperty.call(COLOR_HEX, draft.topColor)) return false;
        if (draft.bottomColor && !Object.prototype.hasOwnProperty.call(COLOR_HEX, draft.bottomColor)) return false;
        if (typeof draft.petName !== 'string' || draft.petName.length > 12) return false;
        return true;
      }

      function restoreDraftBowls() {
        var drafts = readDraftBowls().filter(isValidStoredBowl);
        stateHydrating = true;
        drafts.forEach(function (draft) {
          var index = Number(draft.slotIndex);
          setBowlState(index, Object.assign({}, draft, { syncedToCart: draft.syncedToCart === true, cartLineKey: draft.cartLineKey || null }));
        });
        stateHydrating = false;
      }

      function getBowlVariant(bowl) {
        return bowl ? VARIANT_MAP[bowl.model + '|' + bowl.size] : null;
      }

      function setBowlState(index, patch) {
        var bowl = configuratorState.bowls[index];
        if (!bowl) return null;
        var configurationKeys = ['model', 'size', 'topColor', 'bottomColor', 'petName'];
        var configurationChanged = configurationKeys.some(function (key) {
          return Object.prototype.hasOwnProperty.call(patch || {}, key) && String(bowl[key] || '') !== String(patch[key] || '');
        });
        Object.keys(patch || {}).forEach(function (key) {
          bowl[key] = patch[key];
        });
        if (configurationChanged && !stateHydrating && !Object.prototype.hasOwnProperty.call(patch || {}, 'confirmed')) bowl.confirmed = false;
        var variant = getBowlVariant(bowl);
        bowl.variantId = variant ? variant.id : null;
        bowl.price = variant ? variant.priceCents : 0;
        bowl.properties = {
          'Model': bowl.model || '',
          'Rozmiar': bowl.size || '',
          'Kolor górnej części': bowl.topColor || '',
          'Kolor dolnej części': bowl.bottomColor || '',
          'Imię pupila': (bowl.petName || '').toUpperCase()
        };
        persistDraftBowls();
        refreshPurchaseFlow();
        refreshConfirmationControls();
        return bowl;
      }

      function resetBowlState(index) {
        configuratorState.bowls[index] = emptyBowlState(index);
        persistDraftBowls();
        refreshPurchaseFlow();
      }

      function syncMainBowlState(markStarted) {
        var main = getMainSelection();
        var bowl = setBowlState(0, {
          enabled: true,
          started: bowlStartedValue(0, markStarted),
          model: main.wzor,
          size: main.rozmiar,
          topColor: main.colorTop,
          bottomColor: main.colorBottom,
          petName: main.name
        });
        document.querySelectorAll('#buy_section form[action*="/cart/add"]').forEach(function (form) {
          [
            ['Model', bowl.model || ''],
            ['Rozmiar', bowl.size || '']
          ].forEach(function (entry) {
            var selector = 'input[data-noku-main-property="' + entry[0] + '"]';
            var input = form.querySelector(selector);
            if (!input) {
              input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'properties[' + entry[0] + ']';
              input.setAttribute('data-noku-main-property', entry[0]);
              form.appendChild(input);
            }
            input.value = entry[1];
          });
        });
        return bowl;
      }

      function bowlCartProperties(bowl, slot) {
        var properties = {
          'Model': bowl.model || '',
          'Rozmiar': bowl.size || '',
          'Kolor górnej części': bowl.topColor || '',
          'Kolor dolnej części': bowl.bottomColor || '',
          'Imię pupila': (bowl.petName || '').trim().toUpperCase(),
          '_noku_instance_id': bowl.instanceId
        };
        if (slot) properties['_wezel'] = slot;
        return properties;
      }

      function getMainSelection() {
        var wzorEl = document.querySelector('#buy_section input[name^="Wzór-"]:checked');
        var rozmiarEl = document.querySelector('#buy_section input[name^="Rozmiar-"]:checked');
        var colorTop = document.querySelector('#buy_section select[name="properties[Kolor górnej części]"]');
        var colorBottom = document.querySelector('#buy_section select[name="properties[Kolor dolnej części]"]');
        var nameField = document.querySelector(
          '#buy_section input[name="properties[Imię pupila]"], #buy_section textarea[name="properties[Imię pupila]"]'
        );
        return {
          wzor: wzorEl ? wzorEl.value : null,
          rozmiar: rozmiarEl ? rozmiarEl.value : null,
          colorTop: colorTop ? colorTop.value : '',
          colorBottom: colorBottom ? colorBottom.value : '',
          name: nameField ? nameField.value : ''
        };
      }

      var MAIN_PRODUCT_ID = config.MAIN_PRODUCT_ID;
      var latestCartSnapshot = null;
      var initialStateRestored = false;
      var cartMutationBusy = false;
      var cartActionButton = null;

      function applyMainBowlStateToDOM(bowl) {
        if (!bowl || !bowl.started) return;
        var model = document.querySelector('#buy_section input[name^="Wzór-"][value="' + CSS.escape(bowl.model || '') + '"]');
        var size = document.querySelector('#buy_section input[name^="Rozmiar-"][value="' + CSS.escape(bowl.size || '') + '"]');
        var colorTop = document.querySelector('#buy_section select[name="properties[Kolor górnej części]"]');
        var colorBottom = document.querySelector('#buy_section select[name="properties[Kolor dolnej części]"]');
        var nameField = document.querySelector('#buy_section input[name="properties[Imię pupila]"], #buy_section textarea[name="properties[Imię pupila]"]');
        var nameProxy = document.querySelector('[data-pet-name-proxy]');
        if (model) model.checked = true;
        if (size) size.checked = true;
        if (colorTop && bowl.topColor) colorTop.value = bowl.topColor;
        if (colorBottom && bowl.bottomColor) colorBottom.value = bowl.bottomColor;
        if (nameField) nameField.value = bowl.petName || '';
        if (nameProxy) {
          nameProxy.value = bowl.petName || '';
          var nameCount = document.querySelector('[data-pet-name-count]');
          if (nameCount) nameCount.textContent = nameProxy.value.length;
        }
        syncOptionTiles();
        syncColorTileState();
        refreshConfirmationControls();

        var variant = getBowlVariant(bowl);
        var galleryImage = document.querySelector(
          '#buy_section media-gallery slideshow-slide[aria-hidden="false"] .product-media__image, ' +
          '#buy_section media-gallery .product-media__image'
        );
        if (variant && variant.imageUrl && galleryImage) {
          galleryImage.src = variant.imageUrl;
          galleryImage.srcset = variant.imageUrl;
          if (variant.imageAlt) galleryImage.alt = variant.imageAlt;
        }
      }

      function ensureMainInCart() {
        return syncBowlInstanceToCart(configuratorState.bowls[0], 0);
      }

      function isBowlComplete(bowl) {
        return !!(bowl && bowl.enabled && bowl.started && bowl.variantId && bowl.topColor && bowl.bottomColor && bowl.petName && bowl.petName.trim());
      }

      function syncMainSelection() {
        syncMainBowlState(true);
      }

      document.addEventListener('change', function (event) {
        var target = event.target;
        if (!target || !target.matches) return;
        if (target.matches(
          '#buy_section input[type="radio"][name^="Wzór-"], ' +
          '#buy_section input[type="radio"][name^="Rozmiar-"], ' +
          '#buy_section select[name="properties[Kolor górnej części]"], ' +
          '#buy_section select[name="properties[Kolor dolnej części]"]'
        )) syncMainSelection();
      });

      document.addEventListener('input', function (event) {
        var target = event.target;
        if (!target || !target.matches) return;
        if (target.matches(
          '#buy_section input[name="properties[Imię pupila]"], ' +
          '#buy_section textarea[name="properties[Imię pupila]"]'
        )) syncMainSelection();
      });

      var STEEL_BOWL_VARIANTS = config.STEEL_BOWL_VARIANTS;
      var STEEL_BOWL_PRICES = config.STEEL_BOWL_PRICES;
      var STEEL_BOWL_IMAGE_URL = config.STEEL_BOWL_IMAGE_URL;

      function setCartBusy(busy, button) {
        cartMutationBusy = busy;
        cartActionButton = busy ? button : null;
        cartRefreshSeq += 1;
        document.querySelectorAll('#buy_section .color-picker-wrap, #buy_section .pet-name-wrap, #buy_section .noku-purchase-flow').forEach(function (root) {
          root.inert = busy;
          root.setAttribute('aria-busy', String(busy));
        });
        document.querySelectorAll('[data-noku-checkout], .cart-panel__line-remove').forEach(function (control) { control.disabled = busy; });
        refreshConfirmationControls();
        syncSteelDraftUI();
        refreshPurchaseFlow();
      }

      function runCartMutation(task, button) {
        if (cartMutationBusy) return Promise.reject(new Error('Poczekaj na zakończenie poprzedniej operacji.'));
        document.querySelectorAll('[data-cart-action-error], [data-cart-panel-error]').forEach(function (el) { el.hidden = true; });
        setCartBusy(true, button);
        var taskError = null;
        return Promise.resolve().then(task).catch(function (error) {
          taskError = error;
        }).then(function () {
          return cartRequest('/cart.js');
        }).then(function (cart) {
          renderCartPanel(cart);
          notifyCartUpdate('update', cart.items.map(function (item) { return { id: item.key, quantity: item.quantity }; }));
          if (taskError) throw taskError;
          return cart;
        }).finally(function () {
          setCartBusy(false);
          refreshCartState();
        });
      }

      function removeCartLine(lineKey, button) {
        return runCartMutation(function () {
          return cartRequest('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: 0 })
          });
        }, button);
      }

      function removeBowl(index, lineKey, button) {
        var bowl = configuratorState.bowls[index];
        return removeCartLine(lineKey || bowl.cartLineKey, button);
      }

      function removeSteelBowl(variantId, lineKey, button) {
        var line = (latestCartSnapshot && latestCartSnapshot.items || []).find(function (item) {
          return lineKey ? item.key === lineKey : Number(item.variant_id) === Number(variantId);
        });
        return line ? removeCartLine(line.key, button) : Promise.resolve();
      }

      function reconcileBowlState(cart) {
        stateHydrating = true;
        configuratorState.bowls.forEach(function (bowl, index) {
          var item = (cart.items || []).find(function (line) {
            return cartItemInstanceId(line) === bowl.instanceId || bowl.cartLineKey && line.key === bowl.cartLineKey;
          });
          if (item) {
            bowl.syncedToCart = true;
            bowl.cartLineKey = item.key;
            bowl.confirmed = Number(item.variant_id) === Number(bowl.variantId) &&
              sameVisibleProperties(item.properties, bowlCartProperties(bowl, bowlSlot(index)));
          } else {
            if (bowl.syncedToCart && index > 0) {
              configuratorState.bowls[index] = emptyBowlState(index);
              if (nokuExtraEditorIndex === index) {
                nokuExtraEditorIndex = null;
                var panel = purchaseFlowRoot && purchaseFlowRoot.querySelector('[data-noku-extra-panel]');
                if (panel) { panel.inert = true; panel.setAttribute('aria-hidden', 'true'); }
              }
              return;
            }
            bowl.syncedToCart = false;
            bowl.cartLineKey = null;
            bowl.confirmed = false;
          }
        });
        stateHydrating = false;
        persistDraftBowls();
      }

      function renderCartPanel(cart) {
        latestCartSnapshot = cart;
        var initial = !initialStateRestored;
        if (initial) {
          restoreDraftBowls();
          initialStateRestored = true;
        }
        reconcileBowlState(cart);
        if (initial) {
          if (configuratorState.bowls[0].started) applyMainBowlStateToDOM(configuratorState.bowls[0]);
          var index = storedExtraEditorIndex;
          if (index > 0 && configuratorState.bowls[index] && configuratorState.bowls[index].started) openExtraEditor(index);
          syncSteelDraftUI();
        }
        renderCartOrderSummary(cart);
        refreshPurchaseFlow();
        refreshConfirmationControls();
      }

      function cartRequest(url, options) {
        return fetch(url, options).then(function (response) {
          if (response.ok) return response.json();
          return response.json().catch(function () { return {}; }).then(function (body) {
            throw new Error(body.description || body.message || 'Nie udało się zaktualizować koszyka.');
          });
        });
      }

      function showConfiguratorError(message, button) {
        var root = button && button.closest('.pet-name-wrap, .noku-add-bowl__panel, .noku-steel-draft, .cart-panel');
        var errorEl = root && root.querySelector('[data-cart-action-error]');
        if (root && !errorEl) {
          errorEl = document.createElement('p');
          errorEl.className = 'cart-panel__error';
          errorEl.setAttribute('data-cart-action-error', '');
          errorEl.setAttribute('role', 'alert');
          root.appendChild(errorEl);
        }
        errorEl = errorEl || document.querySelector('[data-cart-panel-error]');
        if (!errorEl) return;
        errorEl.textContent = message || 'Nie udało się zaktualizować koszyka. Spróbuj ponownie.';
        errorEl.hidden = false;
      }

      function bowlSlot(index) {
        if (index === 1) return 'second-bowl';
        if (index >= 2) return 'extra-bowl';
        return null;
      }

      function sameVisibleProperties(left, right) {
        return ['Model', 'Rozmiar', 'Kolor górnej części', 'Kolor dolnej części', 'Imię pupila', '_noku_instance_id', '_wezel'].every(function (key) {
          return String((left || {})[key] || '') === String((right || {})[key] || '');
        });
      }

      function syncBowlInstanceToCart(bowl, index) {
        if (!isBowlComplete(bowl)) return Promise.reject(new Error('Uzupełnij model, rozmiar, kolory i imię pupila.'));
        var desired = Object.assign({}, bowl);
        var desiredProperties = bowlCartProperties(desired, bowlSlot(index));
        return cartRequest('/cart.js').then(function (cart) {
          var existing = cart.items.find(function (item) {
            return cartItemInstanceId(item) === desired.instanceId || item.key === desired.cartLineKey;
          });
          function addInstance(quantity) {
            return cartRequest('/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: desired.variantId, quantity: quantity, properties: desiredProperties }] })
            }).then(function (result) {
              return result.items ? result.items[0] : result;
            });
          }
          if (!existing) return addInstance(1);
          if (Number(existing.variant_id) !== Number(desired.variantId)) {
            return addInstance(existing.quantity).then(function (added) {
              return cartRequest('/cart/change.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: existing.key, quantity: 0 })
              }).then(function () { return added; }).catch(function (error) {
                return cartRequest('/cart/change.js', {
                  method: 'POST', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: added.key, quantity: 0 })
                }).then(function () { throw error; });
              });
            });
          }
          if (sameVisibleProperties(existing.properties, desiredProperties)) return existing;
          return cartRequest('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: existing.key, quantity: existing.quantity, properties: desiredProperties })
          }).then(function (updatedCart) {
            return updatedCart.items.find(function (item) { return cartItemInstanceId(item) === desired.instanceId; });
          });
        }).then(function (item) {
          setBowlState(index, { syncedToCart: true, confirmed: true, cartLineKey: item && item.key || null });
        });
      }

      function setupMediaStickyWrap() {
        if (document.querySelector('.media-sticky-wrap')) return;
        var mediaGallery = document.querySelector('#buy_section media-gallery');
        if (!mediaGallery || !mediaGallery.parentNode) return;

        var wrap = document.createElement('div');
        wrap.className = 'media-sticky-wrap';
        mediaGallery.parentNode.insertBefore(wrap, mediaGallery);
        wrap.appendChild(mediaGallery);
      }

      function setupOrderLayout() {
        var section = document.getElementById('buy_section');
        if (!section) return;
        var mediaWrap = section.querySelector('.media-sticky-wrap');
        var cartPanel = section.querySelector('[data-cart-panel]');
        if (!mediaWrap || !cartPanel) return;

        var row = section.querySelector('.noku-checkout-row');
        if (!row) {
          row = document.createElement('div');
          row.className = 'noku-checkout-row';
          var newContent = document.createElement('div');
          newContent.className = 'noku-checkout-row__content';
          row.appendChild(newContent);
          row.appendChild(mediaWrap);
          var nameStep = section.querySelector('.pet-name-wrap');
          if (nameStep) nameStep.insertAdjacentElement('afterend', row);
        }
        var content = row.querySelector('.noku-checkout-row__content');

        var badges = section.querySelector('.order-summary-badges');
        var miniLoox = document.querySelector('[data-noku-mini-loox]');
        var proof = content.querySelector('.noku-proof-card');
        if (!proof) {
          proof = document.createElement('div');
          proof.className = 'noku-proof-card';
        }
        if (badges) proof.appendChild(badges);
        if (miniLoox) proof.appendChild(miniLoox);

        var purchaseFlow = section.querySelector('.noku-purchase-flow');

        content.appendChild(cartPanel);
        content.appendChild(proof);
        if (purchaseFlow) content.appendChild(purchaseFlow);
      }

      var purchaseFlowRoot = null;
      var nokuExtraEditorIndex = null;

      function escapeHtml(value) {
        var node = document.createElement('span');
        node.textContent = String(value == null ? '' : value);
        return node.innerHTML;
      }

      function nextDraftIndex() {
        for (var index = 1; index < configuratorState.bowls.length; index += 1) {
          if (!configuratorState.bowls[index].enabled) return index;
        }
        return null;
      }

      function countMainBowlUnits(cart) {
        var steelVariantIds = Object.keys(STEEL_BOWL_VARIANTS).map(function (size) {
          return Number(STEEL_BOWL_VARIANTS[size]);
        });
        return ((cart && cart.items) || []).reduce(function (total, item) {
          var isMainBowl = Number(item.product_id) === Number(MAIN_PRODUCT_ID) && steelVariantIds.indexOf(Number(item.variant_id)) === -1;
          return total + (isMainBowl ? Number(item.quantity || 0) : 0);
        }, 0);
      }

      function updateExtraBowlMarketing() {
        if (!purchaseFlowRoot) return;
        var bowl = nokuExtraEditorIndex !== null ? configuratorState.bowls[nokuExtraEditorIndex] : configuratorState.bowls[0];
        var variant = getBowlVariant(bowl) || VARIANT_MAP['Basic|M : 0,45 L'];
        var regular = purchaseFlowRoot.querySelector('[data-noku-add-bowl-price-regular]');
        if (regular) regular.textContent = variant ? variant.price : '—';
        var thumb = purchaseFlowRoot.querySelector('[data-noku-add-bowl-thumb]');
        if (thumb) thumb.src = variant && variant.imageUrl ? variant.imageUrl : PRODUCT_IMAGE_URL;
      }

      function closeExtraEditor() {
        if (cartMutationBusy) return;
        var closingIndex = nokuExtraEditorIndex;
        nokuExtraEditorIndex = null;
        if (!purchaseFlowRoot) return;
        var panel = purchaseFlowRoot.querySelector('[data-noku-extra-panel]');
        if (panel) {
          panel.inert = true;
          panel.setAttribute('aria-hidden', 'true');
        }
        if (closingIndex !== null && !configuratorState.bowls[closingIndex].syncedToCart) resetBowlState(closingIndex);
        persistDraftBowls();
        refreshPurchaseFlow();
      }

      function openExtraEditor(index) {
        var panel = purchaseFlowRoot.querySelector('[data-noku-extra-panel]');
        if (!panel) return;
        nokuExtraEditorIndex = index;
        var bowl = configuratorState.bowls[index];
        if (!bowl.enabled) {
          setBowlState(index, {
            enabled: true, started: true, confirmed: false,
            model: 'Basic', size: 'M : 0,45 L',
            topColor: Object.keys(COLOR_HEX)[0], bottomColor: Object.keys(COLOR_HEX)[0], petName: ''
          });
        }
        bowl = configuratorState.bowls[index];
        panel.querySelector('[data-extra-model]').value = bowl.model;
        panel.querySelector('[data-extra-size]').value = bowl.size;
        panel.querySelector('[data-extra-top]').value = bowl.topColor;
        panel.querySelector('[data-extra-bottom]').value = bowl.bottomColor;
        panel.querySelector('[data-extra-name]').value = bowl.petName;
        panel.querySelectorAll('[data-extra-model-pills] button').forEach(function (button) {
          button.classList.toggle('is-selected', button.getAttribute('data-value') === bowl.model);
        });
        panel.querySelectorAll('[data-extra-size-pills] button').forEach(function (button) {
          button.classList.toggle('is-selected', button.getAttribute('data-value') === bowl.size);
        });
        var confirm = panel.querySelector('[data-extra-confirm]');
        confirm.setAttribute('data-confirm-bowl-index', String(index));
        panel.inert = false;
        panel.setAttribute('aria-hidden', 'false');
        setupConfirmationButtons();
        refreshPurchaseFlow();
      }

      function toggleExtraEditor() {
        if (cartMutationBusy || !initialStateRestored) return;
        if (nokuExtraEditorIndex !== null) {
          closeExtraEditor();
          return;
        }
        var index = nextDraftIndex();
        if (index !== null) openExtraEditor(index);
      }

      function readExtraEditorValues() {
        if (nokuExtraEditorIndex === null || stateHydrating) return null;
        var panel = purchaseFlowRoot.querySelector('[data-noku-extra-panel]');
        return {
          enabled: true, started: true,
          model: panel.querySelector('[data-extra-model]').value,
          size: panel.querySelector('[data-extra-size]').value,
          topColor: panel.querySelector('[data-extra-top]').value,
          bottomColor: panel.querySelector('[data-extra-bottom]').value,
          petName: panel.querySelector('[data-extra-name]').value.toUpperCase()
        };
      }

      function syncExtraEditor() {
        var values = readExtraEditorValues();
        return values ? setBowlState(nokuExtraEditorIndex, values) : null;
      }

      function refreshPurchaseFlow() {
        if (!purchaseFlowRoot) return;
        var addModule = purchaseFlowRoot.querySelector('[data-noku-add-bowl]');
        var addButton = purchaseFlowRoot.querySelector('[data-noku-add-bowl-toggle]');
        var toggleSurface = purchaseFlowRoot.querySelector('[data-noku-add-bowl-surface]');
        var circle = purchaseFlowRoot.querySelector('[data-noku-add-bowl-circle]');
        var nextExtraButton = purchaseFlowRoot.querySelector('[data-noku-next-extra]');
        var next = nextDraftIndex();
        var isOpen = nokuExtraEditorIndex !== null;
        var bowlUnits = countMainBowlUnits(latestCartSnapshot);
        var addCopy = bowlUnits >= 2 ? 'Skonfiguruj kolejną miskę' : 'Skonfiguruj drugą miskę';
        addModule.classList.toggle('is-active', isOpen);
        addModule.querySelector('[data-noku-add-bowl-title]').textContent = bowlUnits >= 2 ? 'Dodaj kolejną miskę' : 'Dodaj drugą miskę';
        addModule.querySelector('[data-noku-add-bowl-promo]').textContent = bowlUnits >= 2 ? 'Kolejna miska również -15%' : 'Druga miska -15%';
        addButton.disabled = !initialStateRestored || cartMutationBusy || isOpen || next === null;
        addButton.textContent = next === null ? 'Wszystkie 5 konfiguracji jest zajętych' : addCopy;
        addButton.hidden = isOpen;
        toggleSurface.setAttribute('aria-expanded', String(isOpen));
        circle.setAttribute('aria-expanded', String(isOpen));
        circle.setAttribute('aria-label', isOpen ? 'Zamknij konfigurację dodatkowej miski' : addCopy);
        circle.setAttribute('aria-pressed', String(isOpen));
        circle.disabled = cartMutationBusy || !initialStateRestored || !isOpen && next === null;
        var currentExtra = isOpen ? configuratorState.bowls[nokuExtraEditorIndex] : null;
        nextExtraButton.hidden = !(currentExtra && currentExtra.confirmed && currentExtra.syncedToCart && next !== null);
        nextExtraButton.disabled = cartMutationBusy;
        updateExtraBowlMarketing();
        refreshConfirmationControls();
      }

      function syncSteelDraftUI() {
        if (!purchaseFlowRoot) return;
        var toggle = purchaseFlowRoot.querySelector('[data-steel-draft-toggle]');
        var size = purchaseFlowRoot.querySelector('[data-steel-draft-size]');
        var qty = purchaseFlowRoot.querySelector('[data-steel-draft-qty]');
        var price = purchaseFlowRoot.querySelector('[data-steel-draft-price]');
        toggle.disabled = !initialStateRestored || cartMutationBusy || !STEEL_BOWL_VARIANTS[steelDraftState.size];
        toggle.textContent = cartMutationBusy && cartActionButton === toggle ? 'Dodawanie…' : 'Dodaj miskę stalową do koszyka';
        size.value = steelDraftState.size;
        qty.value = steelDraftState.quantity;
        if (price) price.textContent = formatPLN(Number(STEEL_BOWL_PRICES[steelDraftState.size] || 0) / 100);
        purchaseFlowRoot.querySelectorAll('[data-steel-draft-size-pill]').forEach(function (pill) {
          var selected = pill.getAttribute('data-value') === steelDraftState.size;
          pill.classList.toggle('is-selected', selected);
          pill.setAttribute('aria-pressed', String(selected));
        });
      }

      function setupPurchaseFlow() {
        if (purchaseFlowRoot) return;
        var nativeButtons = document.querySelector('#buy_section buy-buttons-component, #buy_section [class*="buy-buttons"]');
        if (!nativeButtons || !nativeButtons.parentNode) return;
        nativeButtons.classList.add('noku-native-buy-hidden');
        nativeButtons.setAttribute('aria-hidden', 'true');
        nativeButtons.inert = true;
        var root = document.createElement('div');
        root.className = 'noku-purchase-flow';
        root.innerHTML = '<section class="noku-add-bowl" data-noku-add-bowl><div class="noku-add-bowl__ribbon"><span data-noku-add-bowl-promo>Druga miska -15%</span><span class="noku-add-bowl__ribbon-badge">-15%</span></div><div class="noku-add-bowl__surface" data-noku-add-bowl-surface role="button" tabindex="0" aria-controls="noku-extra-bowl-panel" aria-expanded="false"><span class="noku-add-bowl__thumb-wrap"><img class="noku-add-bowl__thumb" data-noku-add-bowl-thumb src="" alt="" width="60" height="60"></span><span class="noku-add-bowl__info"><strong class="noku-add-bowl__title" data-noku-add-bowl-title>Dodaj drugą miskę</strong><span class="noku-add-bowl__desc">Skonfiguruj ją po swojemu. Wybierz model, rozmiar, kolory i imię niezależnie od pierwszej. Dla tego samego pupila, drugiego psa albo na prezent.</span><span class="noku-add-bowl__price-row"><strong class="noku-add-bowl__price-now">-15% w koszyku</strong><s class="noku-add-bowl__price-was" data-noku-add-bowl-price-regular>—</s></span><span class="noku-add-bowl__save">Rabat naliczy się automatycznie w koszyku</span><span class="noku-add-bowl__values"><span>✓ Pełna swoboda wyboru wzoru i kolorów</span><span>✓ Rozmiar dopasowany do każdego psa</span><span>✓ Własne imię na każdej misce</span><span>✓ 15% rabatu na drugą i kolejne miski</span></span><small class="noku-add-bowl__note">Wszystkie miski z zamówienia wysyłamy razem.</small></span><button type="button" class="noku-add-bowl__circle" data-noku-add-bowl-circle aria-expanded="false" aria-pressed="false" aria-label="Dodaj drugą miskę"></button></div><div class="noku-add-bowl__content"><button type="button" class="noku-add-bowl__toggle" data-noku-add-bowl-toggle>Dodaj drugą miskę</button><div class="noku-add-bowl__panel" id="noku-extra-bowl-panel" data-noku-extra-panel aria-hidden="true" inert><div class="noku-add-bowl__field"><span class="noku-add-bowl__label">Wzór dodatkowej miski</span><div class="noku-add-bowl__pills" data-extra-model-pills><button type="button" data-value="Basic">Basic</button><button type="button" data-value="Baltic Waves">Baltic Waves</button><button type="button" data-value="Mountain Spirit">Mountain Spirit</button><button type="button" data-value="Ocean Flow">Ocean Flow</button></div><select data-extra-model hidden><option>Basic</option><option>Baltic Waves</option><option>Mountain Spirit</option><option>Ocean Flow</option></select></div><div class="noku-add-bowl__field"><span class="noku-add-bowl__label">Rozmiar dodatkowej miski</span><div class="noku-add-bowl__pills" data-extra-size-pills><button type="button" data-value="S : 0,22 L">S</button><button type="button" data-value="M : 0,45 L">M</button><button type="button" data-value="L : 0,9 L">L</button><button type="button" data-value="XL : 1,8 L">XL</button></div><select data-extra-size hidden><option value="S : 0,22 L">S</option><option value="M : 0,45 L">M</option><option value="L : 0,9 L">L</option><option value="XL : 1,8 L">XL</option></select></div><div class="noku-add-bowl__field noku-add-bowl__field--colors"><span class="noku-add-bowl__label">Kolor dodatkowej miski</span><div class="noku-add-bowl__grid"><label>Kolor góry<select data-extra-top></select></label><label>Kolor dołu<select data-extra-bottom></select></label></div></div><label class="noku-add-bowl__field noku-add-bowl__field--name">Imię na dodatkowej misce<input data-extra-name maxlength="12" placeholder="np. REKSIO"></label><button type="button" class="noku-extra-confirm noku-confirm-button" data-extra-confirm>Dodaj miskę do koszyka</button><button type="button" class="noku-add-bowl__next" data-noku-next-extra hidden>Skonfiguruj kolejną miskę</button></div></div></section>' +
          '<section class="noku-steel-draft"><div class="noku-steel-draft__heading"><img class="noku-steel-draft__image" data-steel-draft-image src="" alt="Dodatkowa miska ze stali nierdzewnej" width="76" height="76"><div class="noku-steel-draft__copy"><h3 class="noku-steel-draft__title">Dodatkowa miska ze stali nierdzewnej</h3><p class="noku-steel-draft__desc">Każda miska NOKU ma w zestawie stalowy wkład. Jeśli chcesz mieć drugi na zmianę, możesz dodać go tutaj.</p><p class="noku-steel-draft__price"><span data-steel-draft-price></span> <span class="noku-steel-draft__price-unit">/ szt.</span></p></div></div><div class="noku-steel-draft__controls"><div class="noku-steel-draft__field"><span class="noku-steel-draft__label">Rozmiar</span><div class="noku-steel-draft__pills"><button type="button" class="noku-steel-draft__pill" data-steel-draft-size-pill data-value="S">S</button><button type="button" class="noku-steel-draft__pill" data-steel-draft-size-pill data-value="M">M</button><button type="button" class="noku-steel-draft__pill" data-steel-draft-size-pill data-value="L">L</button><button type="button" class="noku-steel-draft__pill" data-steel-draft-size-pill data-value="XL">XL</button></div><select data-steel-draft-size hidden><option>S</option><option>M</option><option>L</option><option>XL</option></select></div><div class="noku-steel-draft__qty-row"><span class="noku-steel-draft__label">Ilość</span><div class="noku-steel-draft__qty"><button type="button" data-steel-draft-qty-minus aria-label="Zmniejsz ilość">−</button><input type="number" min="1" max="10" value="1" data-steel-draft-qty aria-label="Ilość stalowych misek"><button type="button" data-steel-draft-qty-plus aria-label="Zwiększ ilość">+</button></div></div><button type="button" class="noku-steel-draft__toggle" data-steel-draft-toggle>Dodaj miskę stalową do koszyka</button></div></section>';
        nativeButtons.parentNode.insertBefore(root, nativeButtons);
        purchaseFlowRoot = root;
        root.querySelector('[data-noku-add-bowl-thumb]').src = PRODUCT_IMAGE_URL;
        root.querySelector('[data-steel-draft-image]').src = STEEL_BOWL_IMAGE_URL;
        var colors = Object.keys(COLOR_HEX);
        ['[data-extra-top]', '[data-extra-bottom]'].forEach(function (selector) {
          var select = root.querySelector(selector);
          colors.forEach(function (color) { var option = document.createElement('option'); option.value = color; option.textContent = color; select.appendChild(option); });
        });
        var toggleSurface = root.querySelector('[data-noku-add-bowl-surface]');
        var circle = root.querySelector('[data-noku-add-bowl-circle]');
        var activateButton = root.querySelector('[data-noku-add-bowl-toggle]');
        function handleSurfaceToggle(event) {
          if (event.target.closest('[data-noku-add-bowl-circle]')) return;
          toggleExtraEditor();
        }
        toggleSurface.addEventListener('click', handleSurfaceToggle);
        toggleSurface.addEventListener('keydown', function (event) {
          if (event.target !== toggleSurface || event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          toggleExtraEditor();
        });
        circle.addEventListener('click', function (event) {
          event.stopPropagation();
          toggleExtraEditor();
        });
        activateButton.addEventListener('click', function (event) {
          event.stopPropagation();
          toggleExtraEditor();
        });
        root.querySelector('[data-noku-next-extra]').addEventListener('click', function (event) {
          event.stopPropagation();
          if (cartMutationBusy) return;
          var index = nextDraftIndex();
          if (index !== null) openExtraEditor(index);
        });
        ['[data-extra-model-pills]', '[data-extra-size-pills]'].forEach(function (selector) {
          var group = root.querySelector(selector);
          group.addEventListener('click', function (event) {
            var button = event.target.closest('button[data-value]');
            if (!button || !group.contains(button)) return;
            group.querySelectorAll('button').forEach(function (item) { item.classList.remove('is-selected'); });
            button.classList.add('is-selected');
            var select = selector.indexOf('model') !== -1 ? root.querySelector('[data-extra-model]') : root.querySelector('[data-extra-size]');
            select.value = button.getAttribute('data-value');
            syncExtraEditor();
          });
        });
        root.querySelector('[data-noku-extra-panel]').addEventListener('change', syncExtraEditor);
        root.querySelector('[data-extra-name]').addEventListener('input', syncExtraEditor);
        root.querySelector('[data-steel-draft-toggle]').addEventListener('click', function () {
          if (cartMutationBusy || !initialStateRestored) return;
          var button = root.querySelector('[data-steel-draft-toggle]');
          var variantId = STEEL_BOWL_VARIANTS[steelDraftState.size];
          var quantityInput = root.querySelector('[data-steel-draft-qty]');
          var quantity = Math.max(1, Math.min(10, Math.floor(Number(quantityInput.value)) || 1));
          steelDraftState.quantity = quantity;
          quantityInput.value = quantity;
          persistDraftBowls();
          if (!variantId) return;
          runCartMutation(function () {
            return cartRequest('/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
            });
          }, button).then(function () {
            showBowlSuccessToast('Stalowy wkład został dodany do koszyka.');
          }).catch(function (error) { showConfiguratorError(error.message, button); });
        });
        root.querySelectorAll('[data-steel-draft-size-pill]').forEach(function (pill) {
          pill.addEventListener('click', function () {
            steelDraftState.size = pill.getAttribute('data-value');
            persistDraftBowls();
            syncSteelDraftUI();
          });
        });
        root.querySelector('[data-steel-draft-size]').addEventListener('change', function (event) { steelDraftState.size = event.target.value; persistDraftBowls(); syncSteelDraftUI(); });
        root.querySelector('[data-steel-draft-qty]').addEventListener('input', function (event) { steelDraftState.quantity = Math.max(1, Math.min(10, Math.floor(Number(event.target.value)) || 1)); event.target.value = steelDraftState.quantity; persistDraftBowls(); syncSteelDraftUI(); });
        root.querySelector('[data-steel-draft-qty-minus]').addEventListener('click', function () { steelDraftState.quantity = Math.max(1, steelDraftState.quantity - 1); persistDraftBowls(); syncSteelDraftUI(); });
        root.querySelector('[data-steel-draft-qty-plus]').addEventListener('click', function () { steelDraftState.quantity = Math.min(10, steelDraftState.quantity + 1); persistDraftBowls(); syncSteelDraftUI(); });
        syncSteelDraftUI();
        refreshPurchaseFlow();
      }

      function renderCartOrderSummary(cart) {
        var panel = document.querySelector('[data-cart-panel]');
        if (!panel) return;
        var wasHidden = panel.hidden;
        var lines = panel.querySelector('[data-cart-panel-lines]');
        var total = panel.querySelector('[data-cart-panel-total]');
        lines.innerHTML = '';
        (cart.items || []).forEach(function (item) {
          var line = document.createElement('div');
          line.className = 'cart-panel__line';
          var visibleProps = Object.keys(item.properties || {}).filter(function (key) { return key.charAt(0) !== '_' && item.properties[key]; });
          var discountText = (item.discounts || []).filter(function (discount) { return Number(discount.amount) > 0; }).map(function (discount) { return discount.title; }).filter(Boolean).join(', ');
          line.innerHTML = '<img class="cart-panel__line-thumb" src="' + escapeHtml(item.image || PRODUCT_IMAGE_URL) + '" alt=""><span class="cart-panel__line-info"><span class="cart-panel__line-title">' + escapeHtml((item.product_title || item.title) + (Number(item.product_id) !== Number(MAIN_PRODUCT_ID) && item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '')) + ' × ' + item.quantity + '</span><span class="cart-panel__line-props">' + visibleProps.map(function (key) { return escapeHtml(key + ': ' + item.properties[key]); }).join(' · ') + (discountText ? '<br><strong>' + escapeHtml(discountText) + '</strong>' : '') + '</span></span><span class="cart-panel__line-price">' + (item.original_line_price > item.final_line_price ? '<s>' + formatPLN(item.original_line_price / 100) + '</s><br>' : '') + formatPLN(item.final_line_price / 100) + '</span>';
          var remove = document.createElement('button');
          remove.type = 'button'; remove.className = 'cart-panel__line-remove'; remove.textContent = '×'; remove.setAttribute('aria-label', 'Usuń ' + (item.product_title || item.title));
          remove.setAttribute('data-cart-line-key', item.key);
          remove.disabled = cartMutationBusy;
          remove.addEventListener('click', function () {
            if (remove.disabled) return;
            remove.disabled = true;
            var bowlIndex = configuratorState.bowls.findIndex(function (bowl) {
              return cartItemInstanceId(item) === bowl.instanceId || bowl.cartLineKey === item.key;
            });
            var steel = Object.keys(STEEL_BOWL_VARIANTS).some(function (size) {
              return Number(STEEL_BOWL_VARIANTS[size]) === Number(item.variant_id);
            });
            var removing = bowlIndex >= 0 ? removeBowl(bowlIndex, item.key, remove) :
              steel ? removeSteelBowl(item.variant_id, item.key, remove) : removeCartLine(item.key, remove);
            removing.catch(function (error) {
              remove.disabled = false;
              showConfiguratorError(error.message);
            });
          });
          line.appendChild(remove); lines.appendChild(line);
        });
        total.textContent = formatPLN((cart.total_price || 0) / 100);
        var shouldShow = cart.item_count > 0;
        panel.toggleAttribute('hidden', !shouldShow);
        if (wasHidden && shouldShow && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          panel.classList.remove('is-entering');
          void panel.offsetWidth;
          panel.classList.add('is-entering');
          panel.addEventListener('animationend', function () {
            panel.classList.remove('is-entering');
          }, { once: true });
        }
        refreshPurchaseFlow();
      }

      function setupCartPanel() {
        var section = document.getElementById('buy_section');
        if (!section) return;
        if (!section.querySelector('[data-cart-panel]')) {
          var tpl = document.getElementById('cart-panel-template');
          if (tpl) section.appendChild(tpl.content.cloneNode(true));
        }
        setupOrderLayout();
        var checkout = section.querySelector('[data-noku-checkout]');
        if (checkout && checkout.dataset.cartBound !== 'true') {
          checkout.dataset.cartBound = 'true';
          checkout.addEventListener('click', function () {
            if (!cartMutationBusy && latestCartSnapshot && latestCartSnapshot.item_count > 0) window.location.assign('/checkout');
          });
          refreshCartState();
        }
      }

      function setupBuyboxSteps() {
        setupCoreConfigCard();
        setupColorSliders();
        setupPetName();
        enhanceNativeNameField();
        setupProofBadges();
        setupMediaStickyWrap();
        setupPurchaseFlow();
        setupOrderLayout();
        setupConfirmationButtons();
        setupCartPanel();
        setupOrderLayout();
      }

      function allBuyboxStepsReady() {
        return !!(
          document.querySelector('.core-config-card') &&
          document.querySelector('.color-picker-wrap') &&
          document.querySelector('.pet-name-wrap') &&
          document.querySelector('.order-summary-badges') &&
          document.querySelector('.noku-purchase-flow') &&
          document.querySelector('.cart-panel')
        );
      }

      var buyboxSetupInterval = null;

      function attemptBuyboxSetup() {
        syncOptionTiles();
        setupBuyboxSteps();
        if (allBuyboxStepsReady() && buyboxSetupInterval) {
          clearInterval(buyboxSetupInterval);
          buyboxSetupInterval = null;
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attemptBuyboxSetup);
      } else {
        attemptBuyboxSetup();
      }
      buyboxSetupInterval = setInterval(attemptBuyboxSetup, 150);
      setTimeout(function () {
        if (buyboxSetupInterval) {
          clearInterval(buyboxSetupInterval);
          buyboxSetupInterval = null;
        }
      }, 8000);
    })();
  